// extracted by mini-css-extract-plugin
export var legendIndicator = "_ek-1";
export var legendRight = "_ek-0";